import { render, staticRenderFns } from "./HeaderIntroImage.vue?vue&type=template&id=54a284a6&"
import script from "./HeaderIntroImage.vue?vue&type=script&lang=js&"
export * from "./HeaderIntroImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports